import { createI18n, useI18n as baseUseI18n } from 'vue-i18n';
import i18nMessagesEn from './en.json';
import i18nMessagesEs from './es.json';

import type { UseI18nOptions, VueI18n } from 'vue-i18n';

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: (navigator?.languages?.[0] ?? navigator?.language ?? '').split('-')[0] || 'en',
    fallbackLocale: 'en',
    messages: {
        en: i18nMessagesEn,
        es: i18nMessagesEs
    }
});

export const { t } = i18n.global;

// Alias to fix type errors with the base injection.
export function useI18n(options?: UseI18nOptions): VueI18n {
    return baseUseI18n(options) as never;
}

export default i18n;